import { Outlet } from 'react-router-dom'
import Box from '@mui/material/Box'

export function AuthLayout() {
  return (
    <Box sx={{ minHeight: '100vh' }}>
      <Outlet />
    </Box>
  )
}
